module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/2_b81cb883ecc013745c7313957c47baf0.png";